export default {
  title: 'Paga con {{method}}',
  hint: 'Tocca il pulsante qui sotto e approva il pagamento nella finestra {{method}}.',
  confirming: 'Confermando il pagamento…',
  cancel: 'Annulla pagamento',
  unavailable: 'Questo metodo di pagamento non è disponibile al momento. Scegline un altro.',
  approval_timeout:
    'Non abbiamo ricevuto risposta da {{method}}. Se la finestra non si è aperta, controlla che i pop-up siano consentiti, poi riprova o scegli un altro metodo di pagamento.',
};
